import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;

// PDCA 字典（问题来源 / 课题层级 / 标准类型）
export const reqPdcaDicts = params => { return axios({ method: 'post', url: `${base}/pdca/dicts`, params: params }).then(res => res.data); }

// 课题列表（分页）
export const reqPdcaItemList = params => { return axios({ method: 'post', url: `${base}/pdca/itemlist`, params: params }).then(res => res.data); }

// 课题详情
export const reqPdcaItemDetail = params => { return axios({ method: 'post', url: `${base}/pdca/itemdetail`, params: params }).then(res => res.data); }

// 保存课题（存入问题池 draft / 立项 planning）
export const reqPdcaItemSave = params => { return axios({ method: 'post', url: `${base}/pdca/itemsave`, params: params }).then(res => res.data); }

// 删除课题
export const reqPdcaItemDelete = params => { return axios({ method: 'post', url: `${base}/pdca/itemdelete`, params: params }).then(res => res.data); }

// 状态流转（P/D/C/A 门禁）
export const reqPdcaItemTransition = params => { return axios({ method: 'post', url: `${base}/pdca/itemtransition`, params: params }).then(res => res.data); }

// 关闭课题
export const reqPdcaItemClose = params => { return axios({ method: 'post', url: `${base}/pdca/itemclose`, params: params }).then(res => res.data); }

// 生成下一轮课题
export const reqPdcaItemNextCycle = params => { return axios({ method: 'post', url: `${base}/pdca/itemnextcycle`, params: params }).then(res => res.data); }

// 保存对策
export const reqPdcaActionSave = params => { return axios({ method: 'post', url: `${base}/pdca/actionsave`, params: params }).then(res => res.data); }

// 删除对策
export const reqPdcaActionDelete = params => { return axios({ method: 'post', url: `${base}/pdca/actiondelete`, params: params }).then(res => res.data); }

// 更新对策状态（done 需带完成证据）
export const reqPdcaActionStatus = params => { return axios({ method: 'post', url: `${base}/pdca/actionstatus`, params: params }).then(res => res.data); }

// 我的对策任务
export const reqPdcaActionMyList = params => { return axios({ method: 'post', url: `${base}/pdca/actionmylist`, params: params }).then(res => res.data); }

// 登记标准化产出
export const reqPdcaStandardSave = params => { return axios({ method: 'post', url: `${base}/pdca/standardsave`, params: params }).then(res => res.data); }

// 删除标准化产出
export const reqPdcaStandardDelete = params => { return axios({ method: 'post', url: `${base}/pdca/standarddelete`, params: params }).then(res => res.data); }

// 看板统计
export const reqPdcaKanban = params => { return axios({ method: 'post', url: `${base}/pdca/kanban`, params: params }).then(res => res.data); }

// 经营报表
export const reqPdcaReport = params => { return axios({ method: 'post', url: `${base}/pdca/report`, params: params }).then(res => res.data); }
